<template>
  <div style="position: fixed;z-index:1; width: 880px;">
    <div
      v-for="(expense, expenseIndex) in expenses"
      :key="'memory-preview-expense-' + expenseIndex"
    >
      <div
        class="flex justify-between border-bottom border-blue w-full h-fit mt-6"
      >
        <span class="text-blue text-lg font-bold">
          経費{{ expenseIndex + 1 }}/{{ expenses.length }}
        </span>
        <span class="flex flex-row text-blue">
          <div>
            <!-- 総支出 -->
            <span>{{ makeProratedText(expense) }}</span>
            <span class="mx-0.5">/</span>
            <span class="h-fit text-lg font-bold">総</span>
            <span class="text-sm font-bold">支出</span>
            <span class="text-lg font-bold">{{ totalExpensesText }}</span>
          </div>
        </span>
      </div>
      <AppTable v-bind="$attrs" class="ml-3 mr-3" style="width:840px">
        <template v-slot:table-body>
          <!-- 基本情報 -->
          <tr
            v-for="(title, headerIndex) in getBasicHeader(expense.type[0].id)"
            :key="expenseIndex + '-memory-preview-basic-header-' + headerIndex"
            class="flex border border-collapse border-dashed border-blue border-t-0 border-l-0 border-r-0 h-10"
            :class="getAttr(title) === 'officeMessage' ? 'border-none' : ''"
            :style="
              getAttr(title) == 'officeMessage' && currentUser.role_id == 1
                ? 'display:none;'
                : ''
            "
            style="height:auto;"
          >
            <td
              class="mt-2 items-center justify-center"
              style="width:30px; position: relative; top:3px;"
              v-if="currentPoliticalAction.memory.option.viewType == 4"
            >
              <approved-icn width="20" height="20" />
            </td>
            <td
              class="mt-2 items-center justify-center"
              style="width:30px; position: relative; top:3px;"
              v-else-if="currentPoliticalAction.memory.option.viewType === 1"
            >
              <approved-icn class="status-blue" width="20" height="20" />
            </td>
            <td
              class="mt-2 items-center justify-center"
              style="width:30px; position: relative;"
              v-else
            >
              <rejected-icn
                v-if="
                  ((currentPoliticalAction.memory.option.viewType === 7 ||
                    currentPoliticalAction.memory.option.viewType === 3) &&
                    sentBackTitle().includes(
                      getAttr(title)
                        .split(/(?=[A-Z])/)
                        .join('_')
                        .toLowerCase() +
                        (expenseIndex + 1),
                    )) ||
                    rejectComment(getAttr(title), expenseIndex + 1)
                "
                class="mb-1"
                width="20"
                height="20"
              />
              <wait-yellow-icn class="mt-1" v-else width="20" height="20" />
            </td>
            <td class="mt-2 items-center justify-center" width="150px">
              <span class="text-lg text-blue font-bold">{{ title }}</span>
              <LetterGreen
                v-if="getAttr(title) == 'officeMessage'"
                class="pt-1 ml-1 mb-2 blue-icon"
                style="display: inline-block;"
                width="18px"
                height="18px"
              ></LetterGreen>
            </td>
            <td class="mt-2 items-center justify-center">
              <AppPreviewSentBackItem
                color="blue"
                :message="
                  getSentBackItemMessage(
                    getAttr(title)
                      .split(/(?=[A-Z])/)
                      .join('_')
                      .toLowerCase() +
                      (expenseIndex + 1),
                  )
                "
              />
              <div
                v-if="rejectComment(getAttr(title), expenseIndex + 1)"
                class="flex flex-row items-center"
              >
                <rejected-icn
                  class="mt-1.5 mr-1"
                  style="display: inline-block; margin-top: 4px;"
                  width="16"
                  height="16"
                />
                <span
                  class="text-lg mt-1"
                  style="width: 590px; white-space: normal; align-items: center; word-wrap: break-word;"
                >
                  {{ rejectComment(getAttr(title), expenseIndex + 1) }}<br />
                </span>
              </div>
              <span>
                <template v-if="title === '項目種別'">
                  {{ makeTypeText(expense.type) }}
                </template>

                <template
                  v-else-if="
                    title === '宿泊日' && [1].includes(expense.type[0].id)
                  "
                >
                  {{ expense?.stayDays ?? 0 }}日
                </template>
                <!-- TODO 非表示中の項目 -->
                <!-- <template
                  v-else-if="
                    title === '経路' && [3].includes(expense.type[0].id)
                  "
                >
                  {{ makeTransportationText(expense) }}
                </template>

                <template
                  v-else-if="
                    title === '人数' && [1, 2, 3].includes(expense.type[0].id)
                  "
                >
                  {{ expense?.people ?? 0 }}人
                </template>

                <template
                  v-else-if="
                    title === '距離' && [3].includes(expense.type[0].id)
                  "
                >
                  {{ expense?.distance ?? 0 }}Km
                </template>

                <template
                  v-else-if="
                    title === '1人あたりの料金' &&
                      [1].includes(expense.type[0].id)
                  "
                >
                  {{ makeAmountText(expense?.amount) }}
                </template>

                <template
                  v-else-if="
                    title === '研修内容' && [4].includes(expense.type[0].id)
                  "
                >
                  {{ expense?.item ?? '' }}
                </template>

                <template
                  v-else-if="
                    title === '明細' && [5].includes(expense.type[0].id)
                  "
                >
                  {{ expense?.detail ?? '' }}
                </template> -->
              </span>
            </td>
          </tr>

          <!-- 内容 -->
          <template v-if="expense.receipt">
            <tr
              v-for="(title, contentIndex) in contentHeaders"
              :key="
                expenseIndex + '-memory-preview-basic-header-' + contentIndex
              "
              class="flex border border-collapse border-dashed border-blue border-t-0 border-l-0 border-r-0 h-10"
              style="height:auto;"
              :style="
                (!expense.receipt.haveReceiptImages &&
                  title === '債権者住所・氏名') ||
                (expense.receipt.haveReceiptImages && title === '領収書')
                  ? 'display:none'
                  : ''
              "
            >
              <td
                class="mt-2 items-center justify-center"
                style="width:30px; position: relative; top:3px;"
                v-if="currentPoliticalAction.memory.option.viewType == 4"
              >
                <approved-icn width="20" height="20" />
              </td>
              <td
                class="mt-2 items-center justify-center"
                style="width:30px; position: relative; top:3px;"
                v-else-if="currentPoliticalAction.memory.option.viewType === 1"
              >
                <approved-icn class="status-blue" width="20" height="20" />
              </td>
              <td
                class="mt-2 items-center justify-center"
                style="width:30px; position: relative;"
                v-else
              >
                <rejected-icn
                  v-if="
                    ((currentPoliticalAction.memory.option.viewType === 7 ||
                      currentPoliticalAction.memory.option.viewType === 3) &&
                      sentBackTitle().includes(
                        getAttr(title)
                          .split(/(?=[A-Z])/)
                          .join('_')
                          .toLowerCase() +
                          (expenseIndex + 1),
                      )) ||
                      rejectComment(getAttr(title), expenseIndex + 1)
                  "
                  class="mb-1"
                  width="20"
                  height="20"
                  style="margin-top: 4px;"
                />
                <wait-yellow-icn v-else class="mt-1" width="20" height="20" />
              </td>
              <td
                class="mt-2 items-center justify-center"
                width="150px"
                style="min-width:150px"
              >
                <span
                  v-if="
                    expense.receipt.haveReceiptImages && title === '支出内容'
                  "
                  class="text-lg text-blue font-bold"
                  >内訳</span
                >
                <span
                  v-else-if="
                    expense.receipt.haveReceiptImages && title === '補記'
                  "
                  class="text-lg text-blue font-bold"
                  >理由</span
                >
                <span v-else class="text-lg text-blue font-bold">{{
                  title
                }}</span>
              </td>
              <td
                class="mt-2 items-center justify-center"
                style="max-width:665px"
              >
                <AppPreviewSentBackItem
                  color="blue"
                  :message="
                    getSentBackItemMessage(
                      getAttr(title)
                        .split(/(?=[A-Z])/)
                        .join('_')
                        .toLowerCase() +
                        (expenseIndex + 1),
                    )
                  "
                />
                <div
                  v-if="rejectComment(getAttr(title), expenseIndex + 1)"
                  class="flex flex-row items-center"
                >
                  <rejected-icn
                    class="mt-1.5 mr-1"
                    style="display: inline-block;"
                    width="16"
                    height="16"
                  />
                  <span
                    class="text-lg mt-1"
                    style="width: 590px; white-space: normal; align-items: center; word-wrap: break-word;"
                  >
                    {{ rejectComment(getAttr(title), expenseIndex + 1) }}<br />
                  </span>
                </div>
                <template v-if="title === '経費項目'">
                  {{
                    actionTypeNames(
                      currentPoliticalAction['selectedActionTypes'],
                    )
                  }}
                </template>
                <template v-else-if="title === '支払額'">
                  {{
                    makeAmountText(
                      expense.receipt?.expenseAmount,
                      expense.receipt?.isPartial,
                      expense.receipt?.partialAmount,
                      expense.receipt?.isDistributed,
                      expense.receipt?.numerator,
                      expense.receipt?.denominator,
                    )
                  }}<br />
                  <span v-if="expense.receipt?.isPartial">
                    {{ expense.receipt?.partialComment }}
                  </span>
                </template>
                <template v-else-if="title === '支払年月日'">
                  {{ makePaymentDateText(expense.receipt.expenseDate) }}
                </template>
                <template v-else-if="title === '支出内容'">
                  <span style="word-wrap: break-word;">
                    {{ expense.receipt?.expenseContent1 }}
                  </span>
                </template>

                <template v-else-if="title === '補記'">
                  <span style="word-wrap: break-word;">
                    {{ expense.receipt?.expenseContent2 }}
                  </span>
                </template>
                <template v-else-if="title === '債権者住所・氏名'">
                  <span style="word-wrap: break-word;">
                    {{ expense.receipt?.creditorInfo }}
                  </span>
                </template>
                <!-- 領収書添付 -->
                <template
                  v-else-if="
                    title === '領収書' && !expense.receipt.haveReceiptImages
                  "
                >
                  <tr
                    class="flex"
                    style="height:auto; width:590px"
                    v-for="(image, imageIndex) in expense.image"
                    :key="expenseIndex + '-image-' + imageIndex"
                  >
                    <td
                      style="{display:block;width:92%;height:auto;margin:0 auto}"
                    >
                      <span
                        v-if="currentUser.role_id !== 1"
                        :class="`text-red mb-1 ml-1`"
                        >※画像クリックで黒塗りダイアログが開きます</span
                      >
                      <img
                        v-if="image.normalImage"
                        :src="
                          image.blackImage == null
                            ? image.normalImage
                            : image.blackImage
                        "
                        @click="
                          openImgPreview('memory', expenseIndex, {
                            normalImage: image.normalImage,
                            blackImage: image.blackImage,
                            index: imageIndex,
                          })
                        "
                      />
                    </td>
                  </tr>
                </template>
                <template v-else-if="title == '添付資料'">
                  <span class="text-lg">
                    <div
                      v-for="(file, index) in expense.additionalResources"
                      :key="index"
                    >
                      <span
                        class="hover:text-blue
                  "
                        style="cursor: pointer;"
                        @click="downloadOrPreview(file, expense.receipt.id)"
                      >
                        {{ file.display ? file.display : file.name }}</span
                      >
                    </div>
                  </span>
                </template>
              </td>
            </tr>
          </template>
        </template>
      </AppTable>
    </div>
    <div>
      <tr
        v-for="(OfficeMessage, index) in memoryOfficeMessage"
        :key="'-memory-preview-basic-header-' + index"
        class="flex mb-5 h-10"
        :style="currentUser.role_id == 1 ? 'display:none;' : ''"
        style="height:auto;"
      >
        <td
          class="mt-3 items-center justify-center"
          style="width:30px; position: relative; top:3px;"
          v-if="currentPoliticalAction.memory.option.viewType == 4"
        >
          <approved-icn width="20" height="20" />
        </td>
        <td
          class="mt-3 items-center justify-center"
          style="width:30px; position: relative; top:3px;"
          v-else-if="currentPoliticalAction.memory.option.viewType === 1"
        >
          <approved-icn class="status-blue" width="20" height="20" />
        </td>
        <td
          class="mt-3 items-center justify-center"
          style="width:30px; position: relative;"
          v-else
        >
          <rejected-icn
            v-if="
              ((currentPoliticalAction.memory.option.viewType === 7 ||
                currentPoliticalAction.memory.option.viewType === 3) &&
                sentBackTitle().includes('office_message')) ||
                OfficeMessage.comment
            "
            class="mb-1 ml-3.5"
            width="20"
            height="20"
          />
          <wait-yellow-icn v-else class="ml-3.5" width="20" height="20" />
        </td>
        <td class="mt-2 items-center justify-center" width="150px">
          <span class="text-lg text-blue font-bold ml-3">メッセージ</span>
          <LetterGreen
            class="pt-1 ml-1 mb-2 blue-icon"
            style="display: inline-block;"
            width="18px"
            height="18px"
          ></LetterGreen>
        </td>
        <td class="mt-2 items-center justify-center">
          <AppPreviewSentBackItem
            color="blue"
            :message="getSentBackItemMessage('office_message')"
          />
          <div v-if="OfficeMessage.comment" class="flex flex-row items-center">
            <rejected-icn
              class="mt-1.5 mr-1"
              style="display: inline-block;"
              width="16"
              height="16"
            />
            <span
              class="text-lg"
              style="width: 590px; white-space: normal; align-items: center; word-wrap: break-word;"
            >
              {{ OfficeMessage.comment }}<br />
            </span>
          </div>
          <div
            v-if="
              !OfficeMessage.comment &&
                !getSentBackItemMessage('office_message')[0]?.isNewest
            "
            class="flex flex-row items-center"
          >
            <span
              class="text-lg text-blue ml-3"
              style="width: 590px; white-space: normal; align-items: center; word-wrap: break-word;"
            >
              新規メッセージは入力されていません<br />
            </span>
          </div>
        </td>
      </tr>
    </div>
  </div>
</template>

<script>
import { computed, getCurrentInstance } from 'vue'
import AppTable from '@/components/ui/AppTable.vue'
import ApprovedIcn from '@/assets/icons/approved.svg?inline'
import RejectedIcn from '@/assets/icons/rejected.svg?inline'
import AppPreviewSentBackItem from '@/components/ui/AppPreviewSentBackItem'
import WaitYellowIcn from '@/assets/icons/wait-yellow.svg?inline'
import LetterGreen from '@/assets/icons/letter-green.svg?inline'
import { useMemoryReject } from '@/services/politicalActionToda/useMemoryReject'
import { useMemoryForm } from '@/services/politicalActionToda/useMemoryForm'
import { usePoliticalActions } from '@/services/politicalActionToda/usePoliticalActions'
import { useDialog } from '@/services/useDialog'
import { useCurrentUser } from '@/services/useCurrentUser'
import { useFileUploader } from '@/services/useFileUploader'

export default {
  name: 'MemoryPreview_TODA',
  components: {
    AppTable,
    ApprovedIcn,
    WaitYellowIcn,
    RejectedIcn,
    AppPreviewSentBackItem,
    LetterGreen,
  },
  setup() {
    const { currentPoliticalAction, actionTypeNames } = usePoliticalActions()
    const {
      rejectHeaders,
      rejectedAttrs,
      memoryOfficeMessage,
    } = useMemoryReject()
    const { downloadOrPreviewFromS3 } = useFileUploader()

    /**
     * @var {Map} type(項目種別)と基本情報配列のMap
     */
    const typeToBasicHeaderMap = new Map([
      // 宿泊費
      [1, ['項目種別', '宿泊日']],
      // 食事代
      [2, ['項目種別']],
      // 交通費
      [3, ['項目種別']],
      // 研修費
      [4, ['項目種別']],
      // その他
      [5, ['項目種別']],
    ])

    const contentHeaders = [
      '経費項目',
      '支払額',
      '支払年月日',
      '支出内容',
      '補記',
      '債権者住所・氏名',
      '領収書',
      '添付資料',
    ]

    /**
     * 基本情報リストを取得する
     *
     * @param {number} type expense.type
     * @returns array
     */
    const getBasicHeader = type => {
      return typeToBasicHeaderMap.get(type)
    }

    const expenseTitleToAttrMap = new Map([
      ['項目種別', 'type'],
      // ['経路', 'transportation'],
      // ['人数', 'people'],
      // ['距離', 'distance'],
      ['宿泊日', 'stayDays'],
      // ['1人あたりの料金', 'price'],
      // ['明細', 'detail'],
      // ['研修内容', 'item'],
      // ['宿泊詳細', 'accommodationDetails'],
      ['経費項目', 'expenseType'],
      ['支払額', 'expenseAmount'],
      ['支払年月日', 'expenseDate'],
      ['支出内容', 'expenseContent'],
      ['補記', 'expenseAddendum'],
      ['債権者住所・氏名', 'creditorInfo'],
      ['領収書', 'file'],
      ['添付資料', 'additionalResources'],
    ])
    const getAttr = title => {
      return expenseTitleToAttrMap.get(title)
    }

    const expenses = computed(() => {
      return currentPoliticalAction.memory.expenses
    })

    /**
     * @var {number} 支出総額
     */
    const totalExpenses = computed(() => {
      return expenses.value.reduce((total, expense) => {
        const amount = expense?.receipt?.expenseAmount ?? 0
        const numerator = expense?.receipt?.numerator ?? 0
        const denominator = expense?.receipt?.denominator ?? 0
        const partialAmount = expense?.receipt?.partialAmount ?? 0
        if (amount === 0) {
          return total
        } else if (expense?.receipt?.isPartial && partialAmount !== 0) {
          return total + partialAmount
        } else if (
          expense?.receipt?.isDistributed &&
          numerator !== 0 &&
          denominator !== 0
        ) {
          return total + prorate(amount, numerator, denominator)
        } else {
          return total + amount
        }
      }, 0)
    })

    /**
     * @var {string} 支出総額。区切り文字付きの文字列
     */
    const totalExpensesText = computed(() => {
      return `${totalExpenses.value.toLocaleString()}円`
    })

    /**
     * 按分する
     *
     * @param {number} amount
     * @param {number} numerator
     * @param {number} denominator
     * @returns number
     */
    const prorate = (amount, numerator, denominator) => {
      return Math.floor((numerator * amount) / denominator)
    }

    /**
     * 項目種別テキストを返す
     *
     * @param {array} type
     * @returns string
     */
    const makeTypeText = type => {
      if (type) {
        return type[0].name
      } else {
        return ''
      }
    }

    /**
     * 充当額または按分したテキストを返す
     *
     * @param {object} expense
     * @returns string
     */
    const makeProratedText = expense => {
      const amount = expense?.receipt?.expenseAmount ?? 0
      const numerator = expense?.receipt?.numerator ?? 0
      const denominator = expense?.receipt?.denominator ?? 0
      const partialAmount = expense?.receipt?.partialAmount ?? 0
      let proratedAmount = amount
      if (expense?.receipt?.isPartial && partialAmount !== 0) {
        proratedAmount = partialAmount
      } else if (
        expense?.receipt?.isDistributed &&
        !(amount === 0 || numerator === 0 || denominator === 0)
      ) {
        proratedAmount = prorate(amount, numerator, denominator)
      }
      return `${proratedAmount.toLocaleString()}円`
    }

    /**
     * 交通手段の文字列を作成する\
     * 例: hoge駅 ~ fuga駅 | 往復
     *
     * @param {object} expense
     * @returns string
     */
    const makeTransportationText = expense => {
      const from = expense?.from ?? ''
      const to = expense?.to ?? ''
      const type = expense?.type ?? []
      const isCar = type.length >= 1 ? type[0].id === 3 : false
      if (!isCar) {
        console.debug(`expense from or to is invalid. to: ${to}, from: ${from}`)
        return ''
      }
      let location = ''
      const roundTrip = expense.isRoundTrip ? ' [往復]' : ''
      return `${from}${location} 〜 ${to}${location}${roundTrip}`
    }

    /**
     * 数値に桁区切り+円をつけた文字列を返す\
     * 按分指定があれば按分した文字列を返す
     * 一部充当があれば一部充当金の文字列を返す
     *
     * @param {number} amount 金額
     * @param {bool} isPartial 一部充当フラグ
     * @param {number|null} partialAmount 一部充当金額
     * @param {bool} isDistributed 按分フラグ
     * @param {number|null} numerator 按分分子
     * @param {number|null} denominator 按分分母
     *
     * @returns string
     */
    const makeAmountText = (
      amount,
      isPartial,
      partialAmount,
      isDistributed,
      numerator = null,
      denominator = null,
    ) => {
      amount = amount ?? 0
      const amountWithComma = amount.toLocaleString()
      if (isPartial) {
        return `${partialAmount.toLocaleString()}円 [${amountWithComma}円一部充当]`
      } else if (isDistributed) {
        const proratedAmount = prorate(amount, numerator, denominator)
        const proratedStr = proratedAmount.toLocaleString()
        return `${amountWithComma}円 [${proratedStr}円 按分 ${numerator}/${denominator}]`
      } else {
        return `${amountWithComma}円`
      }
    }

    /**
     * 支出年月日文字列を取得する\
     * 西暦 | 和暦の形式
     *
     * @param {string} expenseDate 支出年月日
     */
    const makePaymentDateText = expenseDate => {
      if (typeof expenseDate !== 'string') {
        throw new Error('receipt expense date is invalid: ' + expenseDate)
      }
      const app = getCurrentInstance()
      const $filters = app.appContext.config.globalProperties.$filters
      const yearText = $filters.dateFormat(expenseDate)
      const wareki = $filters.wareki(expenseDate)
      return `${yearText} | ${wareki}`
    }

    /**
     * 入力画面で入力した差し戻しコメントを取得する\
     *
     * @param {string} attr 項目名
     * @param {number} index 記録簿のインデックス
     */
    const rejectComment = (attr, index) => {
      let comment = ''
      rejectedAttrs.forEach(rejectedAttr => {
        if (rejectedAttr.target === attr + index) {
          comment = rejectedAttr.comment
        }
      })
      return comment
    }

    /**
     * 差し戻しコメントが入力されたかどうかを取得する\
     */
    const sentBackTitle = () => {
      if (currentPoliticalAction.memory.sentBackItems.length > 0) {
        const sentBackTitles = []
        currentPoliticalAction.memory.sentBackItems[0].items.forEach(
          sentBackItem => {
            sentBackTitles.push(sentBackItem.target)
          },
        )
        return sentBackTitles
      } else {
        return ''
      }
    }

    const downloadOrPreview = (file, receiptId) => {
      if (!file.display) {
        const url = URL.createObjectURL(file)
        if (
          file.type.startsWith('image/png') === true ||
          file.type.startsWith('image/jpeg') === true ||
          file.type.startsWith('application/pdf') === true
        ) {
          window.open(url, 'imgwindow')
        } else if (
          file.type.startsWith(
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          ) === true ||
          file.type.startsWith('application/vnd.ms-excel') === true ||
          file.type.startsWith(
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          ) === true ||
          file.type.startsWith('application/msword') === true
        ) {
          const a = document.createElement('a')
          a.href = url
          a.download = file.name
          a.style.visibility = 'hidden'
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
        }
      } else {
        // 一度保存されている添付資料はs3に保存されているためAPIからs3のパスを取得し処理を行う
        downloadOrPreviewFromS3(receiptId, 2, file, file.display)
      }
    }

    return {
      typeToBasicHeaderMap,
      contentHeaders,
      expenses,
      totalExpenses,
      totalExpensesText,
      currentPoliticalAction,
      actionTypeNames,
      rejectHeaders,
      rejectedAttrs,
      memoryOfficeMessage,
      makeTypeText,
      makeProratedText,
      getBasicHeader,
      getAttr,
      makeTransportationText,
      makeAmountText,
      makePaymentDateText,
      rejectComment,
      sentBackTitle,
      downloadOrPreview,
      downloadOrPreviewFromS3,
      ...useMemoryForm(),
      ...useDialog(),
      ...useCurrentUser(),
    }
  },
}
</script>
<style lang="scss"></style>
